import React from "react";
import cx from "classnames";
import { LogoWhite } from "assets";
import Footer from "../Footer/Footer";
import { TestPill } from "../Header";

export interface ISigninJoiningAppShellProps {
  children: React.ReactNode;
  removePadding?: boolean;
  hideFooter?: boolean;
  "data-testid"?: string;
}

const SigninJoiningAppShell: React.FC<
  React.PropsWithChildren<ISigninJoiningAppShellProps>
> = ({ children, removePadding, hideFooter, "data-testid": dataTestId }) => (
  <main>
    <section
      className="flex min-h-screen flex-col justify-between"
      data-testid={dataTestId}
    >
      <header className="bg-color-neutral-one h-[50px]">
        <div className="flex h-full max-w-[1140px] items-center pl-[15px]">
          <LogoWhite height={30} />
          <TestPill />
        </div>
      </header>
      <main
        className={cx("relative flex flex-1 flex-col text-base", {
          "pt-4": !removePadding,
        })}
      >
        {children}
      </main>
      {!hideFooter && <Footer />}
    </section>
  </main>
);

export default SigninJoiningAppShell;
